var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.141,
    height: 16.141,
    viewBox: "0 0 16.141 16.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#faac1a;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.07,16.141A8.07,8.07,0,1,0,0,8.07,8.07,8.07,0,0,0,8.07,16.141Zm0-.646a8.178,8.178,0,0,0,1.708-.2A7.342,7.342,0,0,0,15.5,8.07,7.425,7.425,0,1,0,8.07,15.5ZM7.748,3.874h.646V9.684H7.748Zm.646,5.165h5.165v.646H8.393Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogress);
export default __webpack_public_path__ + "static/media/inprogress.823859f528c3244a1ec9f3d0a565686b.svg";
export { ForwardRef as ReactComponent };